import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

type Props = { title: string; description?: string; actions?: ReactNode };

export function PageHeader({ title, description, actions }: Props) {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      sx={{ justifyContent: 'space-between', alignItems: { sm: 'flex-end' }, gap: 2, mb: { xs: 3, md: 4 } }}
    >
      <Stack sx={{ gap: 0.75, minWidth: 0 }}>
        <Typography variant="h1">{title}</Typography>
        {description ? (
          <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 720, fontSize: '0.875rem' }}>
            {description}
          </Typography>
        ) : null}
      </Stack>
      {actions ? <Stack direction="row" sx={{ gap: 1, flexShrink: 0, flexWrap: 'wrap' }}>{actions}</Stack> : null}
    </Stack>
  );
}
